// ---------------------------------------------------------
// Datei: CaptionIndicator.tsx
// Zweck: Kleines Kommentar-Icon-Badge in der Ecke einer Foto-Vorschau/Kachel, das anzeigt, dass
//        eine Beschriftung existiert — ohne deren Text direkt in der Kachel zu zeigen (Ticket
//        #1055, Nutzer-Rückmeldung: der volle Beschriftungstext störte den Kachel-Grid-Look).
// Kontext: Wird über der Vorschau positioniert, der umgebende Container muss `position: relative`
//          setzen — überall dort einsetzbar, wo eine markierte Foto-Kachel gerendert wird
//          (Projektvorbereitung, Baustellendoku, VOT).
// ---------------------------------------------------------

import React from 'react';

interface CaptionIndicatorProps {
  caption: string;
  className?: string;
}

const CaptionIndicator: React.FC<CaptionIndicatorProps> = ({
  caption,
  className = 'absolute bottom-1 right-1',
}) => (
  <div
    className={`${className} flex items-center justify-center w-6 h-6 rounded-full bg-black/60 text-white`}
    title={caption}
    aria-label="Beschriftung vorhanden"
  >
    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
      <path d="M18 10c0 3.314-3.582 6-8 6a9.06 9.06 0 01-2.347-.306c-.584.457-1.652 1.107-2.91 1.257a.5.5 0 01-.54-.65c.156-.51.311-1.204.319-1.746A5.98 5.98 0 012 10c0-3.314 3.582-6 8-6s8 2.686 8 6z" />
    </svg>
  </div>
);

export default CaptionIndicator;
